import SelectList from "types/SelectList";

const CURRENCY_LIST: SelectList = [
  { value: "USD", label: "Dolar Americano (USD)" },
  { value: "BRL", label: "Real Brasileiro (BRL)" },
  { value: "EUR", label: "Euro (EUR)" },
  { value: "GBP", label: "Libra Esterlina (GBP)" },
  { value: "JPY", label: "Iene (JPY)" },
  { value: "AUD", label: "Dólar Australiano (AUD)" },
  { value: "CAD", label: "Dólar Canadense (CAD)" },
  { value: "CHF", label: "Franco Suíço (Suíça)" },
  { value: "CNY", label: "Yuan Chinês (China)" },
  { value: "ARS", label: "Peso Argentino (Argentina)" },
  { value: "CLP", label: "Peso Chileno (Chile) " },
];

export default CURRENCY_LIST;
